import React from "react";
interface props {
  className?: string;
  height?: string;
  width?: string;
  stroke?: string;
  fill?: string;
  bgFill?: any;
}
function TiltArrow({ className, height, width, stroke, fill, bgFill }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      fill={bgFill || "#fff"}
      viewBox="0 0 42 42"
    >
      <rect
        width="41"
        height="41"
        x="0.5"
        y="0.5"
        stroke={stroke || "#666"}
        rx="20.5"
      ></rect>
      <path
        fill={fill || "#000"}
        d="M27.34 24.049a.33.33 0 01-.36-.301l-.662-7.589-8.839 10.53a.33.33 0 11-.506-.425l8.839-10.53-7.589.663a.334.334 0 01-.322-.177.332.332 0 01.265-.482l8.384-.732a.33.33 0 01.358.3l.732 8.385a.332.332 0 01-.3.358z"
      ></path>
    </svg>
  );
}

export default TiltArrow;
